export const ATTRIBUTION_ILLUSTRATION_PATH:string = '/illustrations/Attribution/';
export const INTRODUCTION_ILLUSTRATION_PATH:string = '/illustrations/Cover/';
export const FUNDS_ILLUSTRATION_PATH:string = '/illustrations/Funds/';
export const NEWS_ILLUSTRATION_PATH:string = '/illustrations/News/';